import { routes } from '@/domains/core/routing/routes/routes.default';

export const generateBrandPath = (slug: string, brandId: number) =>
  `/${routes.brand.split('/')[1]}/${slug}-${brandId}`;
